<div class="kt-portlet container">
	<div class="kt-portlet__head">
		<div class="encabezado mt-3">
			<h1 class="titulo"><i class="fas fa-engine-warning"></i>&nbsp;{{titulo}}</h1>
		</div>
		<div class="row">
			<!--<button id="agregarBoton" mat-raised-button class="btn btn-success" (click)="navegarMaqueta()"
				style="margin-right: 15px;"><i class="fas fa-industry"></i>&nbsp;Maqueta</button>&nbsp;-->
			<button id="agregarBoton" mat-raised-button class="btn btn-success mt-3" (click)="navegarGaleria()"
				style="margin-right: 15px;"><i class="fas fa-images"></i>&nbsp;Galeria</button>&nbsp;
			<button id="agregarBoton" mat-raised-button class="btn btn-success mt-3" (click)="navegarFoto()"
				style="margin-right: 15px;"><i class="fas fa-camera"></i>&nbsp;Foto</button>&nbsp;
			<button id="agregarBoton" mat-raised-button class="btn btn-success mt-3" (click)="navegarTranmisiones()"
				style="margin-right: 15px;"><i class="fas fa-satellite-dish"></i>&nbsp;Transmisiones</button>&nbsp;
			<button id="agregarBoton" mat-raised-button class="btn btn-success mt-3" (click)="navegarSinTransmitir()"
				style="margin-right: 15px;"><i class="fas fa-ban"></i>&nbsp;Sin Transmisión</button>&nbsp;
			<kt-boton-exportar-tabla class="mt-3" [tipoBoton]="'grid'" [nombreArchivo]="'Alertados'" [datos]="datosReporte"
				[buttonDisabled]="isDisabled">
			</kt-boton-exportar-tabla>
		</div>
	</div>
	<div class="kt-portlet__body">
		<div class="kt-section">
			<div class="kt-section__content">
				<div class="contenedor-modal">
					<div class="data-grid">
						<dx-data-grid id="gridContainer" [columnHidingEnabled]="true" [dataSource]="listaAlertados"
							[showBorders]="true" (onRowPrepared)="onRowPrepared($event)">
							<dxo-paging [pageSize]="7"></dxo-paging>
							<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[7, 10, 50, 100]"
								[showInfo]="true">
							</dxo-pager>
							<dxo-group-panel [emptyPanelText]="mensajeAgrupar" [visible]="true"></dxo-group-panel>
							<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
							<dxi-column caption="Acciones" cellTemplate="acciones" alignment="center" [width]="100">
							</dxi-column>
							<dxi-column dataField="estado" caption="Estado" alignment="center" [width]="150">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="imei" caption="IMEI" alignment="center" [width]="200">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="economico" caption="Económico" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="placas" caption="Placas" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="nombreCliente" caption="Cliente" alignment="center" [width]="300">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="lat" caption="Latitud" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="lng" caption="Longitud" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="fechaHora" caption="Fecha y Hora" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="velocidad" caption="Velocidad" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="marca" caption="Marca" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="modelo" caption="Modelo" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<div *dxTemplate="let row of 'acciones'">
								<ng-container>
									<dx-button valueExpr="id" id="botonWhiteBlue" class="btnAcciones"
										(click)="abrirImprimir(row.data)">
										<i class="fas fa-file-pdf"></i>
									</dx-button>
								</ng-container>
							</div>
						</dx-data-grid>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false" [message]="loadingMessage">
</dx-load-panel>
